import React from 'react';
import {observer} from 'mobx-react';
import s from '../../s';
import {Portal} from '../../../util';
import PricingStatus from '../pricing-status';
import {getPriceDisplay} from '../../pricing-request/price-display';
import {readPreloadHeading} from '../product-header-title';

declare var __fast_ship: boolean;

/** The portal 3 heading as the app composes it: product 70214, a manual override, or institution / product / document size. */
const composeHeading = (): string => {
    if (s.prod.ProductID === 70214) return 'Graduation Stole Frame';
    const docSize = `Fits ${s.ps.docWidth}"w x ${s.ps.docHeight}"h ${s.prod.DocType}`;
    const gsName = s.si.GSName && s.si.GSName !== '' ? ` - ${s.si.GSName}` : '';
    const degreeType = s.prod.DegreeType ? ` for ${s.prod.DegreeType}` : '';
    if (s.si.ManualOverride_Desc && s.si.ManualOverride_Desc.length > 5) return `${s.si.ManualOverride_Desc}${gsName} - ${docSize}${degreeType}`;
    const showInstInProductH1 = s.prod.TitleShowInstName && !s.si.hide_prod_page_inst_h1;
    return `${showInstInProductH1 ? s.si.InstName : ''}${gsName} - ${s.ui.product_title} - ${docSize}${degreeType}`;
};

export const Header = observer(() => {
    // The server's heading when the page carries one (the shell showed it before mount), else the app's own formula.
    const headingText = readPreloadHeading() ?? composeHeading();

    return (
        <div
            id="prod-header"
            className="portal3"
        >
            {s.prod && s.si && (
                <div>
                    <h1>{headingText}</h1>
                </div>
            )}
            {s.ui.show_pricing && (
                <span
                    className="msrp-disc"
                    aria-busy={s.ui.pricing_loading}
                >
                    {getPriceDisplay(s.ui).current}
                </span>
            )}
            {s.ui.show_pricing && <PricingStatus error={s.ui.pricing_error} />}

            {__fast_ship && s.isRetail && s.si && s.si.StoreTypeID !== 5 && s.__fast_ship_orig && Portal?.PortalID === 3 && (
                <div className={`fast-ship-container-3`}>
                    <div>
                        <i
                            className="fas fa-cart-shopping-fast"
                            aria-hidden={true}
                        ></i>
                    </div>
                    <div>= SHIPS IN 2-3 DAYS</div>
                </div>
            )}
        </div>
    );
});
